import { css } from 'styled-system/css';

export const labelStyle = css.raw({
  textStyle: 'v2.meta',
  color: 'v2.text.muted',
});
export const valueStyle = css.raw({
  textStyle: 'numbers.xsmall',
  color: 'v2.text.secondary',
  textAlign: 'end',
});
